import React from 'react';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import './widget.scss';

const options = [
    { value: '1', label: 'Kavindu Akash ⁃ +94767221831 ◦ Head Usher' },
    { value: '2', label: 'Achira De Silva ⁃ +94767221831 ◦ Usher' },
    { value: '3', label: 'Alistor ⁃ +94767221831 ◦ Usher' },
    { value: '4', label: 'Lakshmi Kanchana ⁃ +94767221831 ◦ Usher' },
    { value: '5', label: 'Lakshan Gamage ⁃ +94767221831 ◦ Usher' },
    { value: '6', label: 'Manesh ⁃ +94767221831 ◦ Usher' },
    { value: '7', label: 'Tharidu Athukorala ⁃ +94767221831 ◦ Usher' },
    { value: '8', label: 'Dineth Egodage ⁃ +94767221831 ◦ Usher' },
    { value: '9', label: 'Nazeer ⁃ +94767221831 ◦ Usher' },
    { value: '10', label: 'Sahan Dinuka ⁃ +94767221831 ◦ Usher' },
    { value: '12', label: 'Navishka ⁃ +94767221831 ◦ Usher' },
    { value: '13', label: 'Daini Nimaya ⁃ +94767221831 ◦ Usher' },
    { value: '14', label: 'Lakshika Madushan ⁃ +94767221831 ◦ Usher' },
    { value: '15', label: 'Binura Salindra ⁃ +94767221831 ◦ Usher' },
    { value: '16', label: 'Chanuka Sadaruwan ⁃ +94767221831 ◦ Usher' },
];

class Widget extends React.Component {

    onChange = (selected) => {
        this.props.setSelectedVolunteers(selected);
        console.log(selected);
    };

    render() {
        let { allvolunteers, selectedvolunteers } =  this.props;

      console.log("All-Volunteers-X: ", allvolunteers);
      console.log("Selected-Volunteers-X: ", selectedvolunteers);

        return (
            <DualListBox
                canFilter
                filterCallback={(option, filterInput) => {
                    if (filterInput === '') {
                        return true;
                    }

                    return (new RegExp(filterInput, 'i')).test(option.label);
                }}
                filterPlaceholder="Search..."
                options={ allvolunteers }
                selected={ selectedvolunteers }
                onChange={ this.onChange }
            />
        );
    }
}

export default Widget;
